<template>
  <div>
    <v-data-table
      id="table-members"
      :headers="headers"
      :items="items"
      class="elevation-0"
      :loading="loading"
      disable-sort
      item-class="properties"
      :dense="false"
      :footer-props="footerProps"
    >
      <template v-slot:item.fullname="{ item }">
        <div class="font-weight-bold">{{ item.fullname }}</div>
      </template>
      <template v-slot:item.memberInstitutionName="{ item }">
        <div>{{ item.memberInstitutionName }}</div>
      </template>
      <template v-slot:item.email="{ item }">
        <div>{{ item.email }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-layout justify-end id="members-buttons">
          <v-btn
            outlined
            depressed
            rounded
            class="font-weight-bold text-capitalize"
            color="black"
            @click="(itemToBeDeleted = item), (deleteDialog = true)"
          >
            Remove
          </v-btn>
          <v-btn
            v-if="adminId !== item.id"
            outlined
            depressed
            rounded
            class="ml-2 font-weight-bold text-capitalize"
            color="black"
            @click="(memberAsAdmin = item), (enabledAdminDialog = true)"
          >
            Set As Administrator
          </v-btn>
          <v-btn
            depressed
            rounded
            class="ml-2 white--text font-weight-bold text-capitalize"
            color="primary200"
            :to="{
              name: 'MemberOverview',
              params: { id: item.id },
              query:
                $store.getters.roles === 'provider'
                  ? { provider: true, institutionId: $route.params.id }
                  : {},
            }"
            >Overview
          </v-btn>
        </v-layout>
      </template>
    </v-data-table>
    <v-dialog v-if="itemToBeDeleted !== null" v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Remove</v-card-title>
        <v-card-text>
          {{ $t('delete.confirm') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="deleteDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="red darken-1" text @click="onDeleteItem" :disabled="disableDelete">
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="memberAsAdmin !== null" v-model="enabledAdminDialog" max-width="500">
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="headline px-0 py-0">
          {{ $t('setMemberAsAdmin.message') }}
        </v-card-title>
        <v-card-text class="pl-0 pt-3">
          {{ $t('setMemberAsAdmin.confirm') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            rounded
            large
            class="neutral800--text font-weight-bold"
            color="neutral"
            outlined
            @click="cancel"
            >{{ $t('cancel') }}
          </v-btn>
          <v-btn
            depressed
            rounded
            large
            class="white--text font-weight-bold"
            color="neutral"
            @click="onMemberAsAdmin"
            >{{ $t('yes') }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'TableMembers',
  mixins: [util],
  props: {
    urlApi: String,
    urlApiDelete: String,
    urlApiAddAsAdmin: String,
    urlApiGetProvider: String,
    urlApiGetHostingRepresentative: String,
    search: Object,
    searchAttributes: Array,
    viewRouter: String,
    adminProvider: Boolean,
  },
  data: () => ({
    firstLoad: true,
    totalItems: 0,
    items: [],
    loading: true,
    options: {},
    itemToBeDeleted: null,
    deleteDialog: false,
    disableDelete: false,
    memberAsAdmin: null,
    memberAsAdminEnabled: new Set(),
    enabledAdminDialog: false,
    headers: [
      {
        text: '',
        value: 'logo',
        width: '10px',
      },
      { text: 'Fullname', value: 'fullName', width: 400 },
      { text: 'Institution', value: 'memberInstitutionName' },
      { text: 'Email', value: 'email' },
      { text: '', value: 'actions' },
    ],
    footerProps: { 'items-per-page-options': [10, 15, 25, 50, 100] },
    adminId: null,
  }),
  watch: {
    options: {
      handler() {
        console.log('[Table] Options watch');
        if (!this.firstLoad) {
          this.changeOptions();
        }
      },
      deep: true,
    },
  },
  mounted() {
    console.log('[Table] Mounted');
    if (this.firstLoad) {
      /* Populate table from route */
      this.options.page = this.$route.query.index ? Number(this.$route.query.index) + 1 : 1;
      this.options.itemsPerPage = this.$route.query.size ? Number(this.$route.query.size) : 10;
      this.options.sortBy = [];
      this.options.sortDesc = [];
      if (this.$route.query.sort) {
        const sortList = this.$route.query.sort.split(',');
        for (let i = 0; i < sortList.length; i += 1) {
          this.options.sortBy.push(sortList[i].split(' ')[0]);
          if (sortList[i].split(' ')[1] === 'asc') {
            this.options.sortDesc.push(false);
          } else {
            this.options.sortDesc.push(true);
          }
        }
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.$route.query[attr]) {
          this.$set(this.search, attr, this.$route.query[attr]);
        }
      }
    }
    this.getDataFromApi().then(data => {
      this.items = data.items;
      this.totalItems = data.total;
      this.firstLoad = false;
    });
    this.getAdminInfo().then(data => {
      this.adminId = data.adminId;
    });
  },
  methods: {
    triggerSearch() {
      console.log('[Table] Search watch');
      if (!this.firstLoad) {
        this.options.page = 1;
        this.changeOptions();
      }
    },
    changeOptions() {
      this.$router.push({
        path: this.$router.path,
        query: this.getParams(),
      });
      let currentPathName = this.$router.currentRoute.name;
      localStorage[currentPathName] = this.$router.currentRoute.fullPath;
    },
    getDataFromApi() {
      console.log('[Table] Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);
      return new Promise(resolve => {
        this.axios
          .get(`${this.urlApi}?`, {
            params: this.getParams(),
          })
          .then(res => {
            let items = [];
            let total = 0;
            if (res.status === 200) {
              items = res.data.content;
              total = res.data.total;
            }
            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total,
              });
            });
          })
          .finally(() => {
            EventBus.$emit('waiting', false);
          });
      });
    },
    getAdminInfo() {
      this.loading = true;
      EventBus.$emit('waiting', true);
      return new Promise(resolve => {
        if (this.urlApiGetProvider) {
          this.axios
            .get(this.urlApiGetProvider)
            .then(res => {
              let adminId = null;
              if (res.status === 200) {
                adminId = res.data?.administratorContact?.id ?? null;
              }
              setTimeout(() => {
                this.loading = false;
                resolve({
                  adminId,
                });
              });
            })
            .finally(() => {
              EventBus.$emit('waiting', false);
            });
        } else if (this.urlApiGetHostingRepresentative) {
          this.axios
            .get(this.urlApiGetHostingRepresentative)
            .then(res => {
              let adminId = null;
              if (res.status === 200) {
                adminId = res.data?.administratorContact?.id ?? null;
              }
              setTimeout(() => {
                this.loading = false;
                resolve({
                  adminId,
                });
              });
            })
            .finally(() => {
              EventBus.$emit('waiting', false);
            });
        }
      });
    },
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const query = {
        index: page - 1,
        size: itemsPerPage,
      };
      let sort = '';
      for (let i = 0; i < sortBy.length; i += 1) {
        if (i !== 0) {
          sort += ',';
        }
        let dir = 'asc';
        if (sortDesc[i]) {
          dir = 'desc';
        }
        sort += `${sortBy[i]} ${dir}`;
      }
      if (sort !== '') {
        query.sort = sort;
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.search[attr]) {
          query[attr] = this.search[attr];
        }
      }
      return query;
    },
    onViewItem(value) {
      console.log('Click View ' + value.id);
      this.$router.push({
        name: this.viewRouter,
        query: { id: value.id },
      });
    },
    onDeleteItem() {
      this.disableDelete = true;
      let value = this.itemToBeDeleted;
      console.log('Click Delete ' + value.id);
      EventBus.$emit('waiting', true);
      this.axios
        .delete((this.urlApiDelete ? this.urlApiDelete : this.urlApi) + '/' + value.id)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('delete.success'),
          });
          this.deleteDialog = false;
          this.$emit('delete', value);
          this.disableDelete = false;
        })
        .catch(error => {
          console.log({ error });
          this.disableDelete = false;
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(EventBus.$emit('waiting', false));
    },
    checkUser(event) {
      let userId = localStorage.getItem('userid');
      return !(userId == event.id);
    },
    onMemberAsAdmin() {
      let value = this.memberAsAdmin;
      console.log('Click Set As Administrator ID', value.id);
      //here
      EventBus.$emit('waiting', true);
      this.axios
        .put(this.urlApiAddAsAdmin + '/' + value.id)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('setMemberAsAdmin.success'),
          });
          this.enabledAdminDialog = false;
          this.memberAsAdminEnabled.add(this.memberAsAdmin.id);
          this.getAdminInfo().then(data => {
            this.adminId = data.adminId;
          });
          if (this.adminProvider) {
            this.$router.push({
              name: 'Dashboard',
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.disableDelete = false;
        })
        .finally(EventBus.$emit('waiting', false));
    },
    cancel() {
      this.enabledAdminDialog = false;
    },
  },
};
</script>

<style>
.v-application--is-ltr .v-data-table__mobile-row__cell {
  text-align: left;
}

tr {
  min-height: 200px;
  height: 100%;
}

#table-providers
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  width: 97px !important;
}
</style>
